import React from 'react';
import {Link, useNavigate} from 'react-router-dom';
import './LeftPanel.css'
import HomeIcon from '../icons/HomeIcon'
import PurchaseIcon from '../icons/PurchaseIcon'
import ProductionIcon from '../icons/ProductionIcon'
import SalesIcon from '../icons/SalesIcon'
import SettingsIcon from '../icons/SettingsIcon';
import StockIcon from '../icons/StockIcon';
import LogoutIcon from '../icons/LogoutIcon';
import MarketDueIcon from '../icons/MarketDueIcon';

const LeftPanel = (props) =>{
    const {tabName} = props;
    const navigate = useNavigate();

    const userRole = JSON.parse(localStorage.getItem('auth')).role;

    const handleLogout = () => {
        localStorage.removeItem('auth');
        navigate('/login')
    }

    return(
        <div className='Body'>
            {/* <Link 
                to = '/'
                className='homeTabBox'
                style={tabName==='home' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <HomeIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft:30}} 
                    marked={tabName==='home' ? 1:0}
                />
                <div className='tabText' 
                    style={tabName==='home' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Home</div>
            </Link> */}
            {userRole === 'Admin' &&
            <Link 
                to='/'
                className='homeTabBox'
                style={tabName==='home' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <HomeIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft:30}} 
                    color='black'
                />
                <div className='tabText' 
                    style={tabName==='home' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Home</div>
            </Link>
            }
            <Link 
                to='/sales'
                className='purchaseTabBox'
                style={tabName==='sales' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <SalesIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft:30}} 
                    marked={tabName==='sales' ? 1:0}
                />
                <div className='tabText' 
                    style={tabName==='sales' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Sales</div>
            </Link>
            <Link 
                to='/market-due'
                className='purchaseTabBox'
                style={tabName==='market-due' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <MarketDueIcon 
                    size={28} 
                    style={{marginTop:10,marginLeft:25}} 

                />
                <div className='tabText' 
                    style={tabName==='market-due' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Market Due</div>
            </Link>
            <Link 
                to = '/daily-expense'
                className='purchaseTabBox'
                style={tabName==='daily-expense' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <StockIcon 
                    size={22} 
                    style={{marginTop:15,marginLeft:30, marginRight:5}} 
                    marked={tabName==='daily-expense' ? 1:0}
                />
                <div className='tabText' 
                    style={tabName==='daily-expense' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Daily Expense</div>
            </Link>
            <Link 
                to='/purchase'
                className='purchaseTabBox'
                style={tabName==='purchase' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <PurchaseIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft:30}} 
                />
                <div className='tabText' 
                    style={tabName==='purchase' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Purchase</div>
            </Link>
            <div className='dropdown'>
                <div 
                    className='purchaseTabBox'
                    style={(tabName==='stock-production' || tabName ==='stock-materials') ?
                    {
                        backgroundColor:'#5CE65B'
                    }:{
                        backgroundColor:'#EDF2F7'
                    }}
                >
                    <ProductionIcon 
                        size={24} 
                        style={{marginTop:10,marginLeft:30}} 
                        marked={(tabName==='stock-production' || tabName ==='stock-materials') ? 1:0}
                    />
                    <div className='tabText' 
                        style={(tabName==='stock-production' || tabName ==='stock-materials') ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                    >Stock</div>
                </div>
            
                <div 
                    className='productionTabBoxDetails'
                    style={
                        (tabName==='stock-production' || tabName ==='stock-materials') ?
                        {display:'block',position:'relative'} : {}
                    }
                >
                    <Link to='/stock-production' className='productionTabText' style={tabName==='stock-production' ? {fontFamily:'PoppinsBold'} : {}} >Production</Link>
                    {tabName ==='stock-production' && <div className='underlineBarExpense' />}
                    <Link to='/stock-materials' className='productionTabText' style={tabName==='stock-materials' ? {fontFamily:'PoppinsBold'} : {}}>Raw Materials</Link>
                    {tabName ==='stock-materials' && <div className='underlineBarPayment' />}

                </div>
            </div>
            
            {userRole === 'Admin' &&
            <Link 
                to='/attendance'
                className='purchaseTabBox'
                style={tabName==='attendance' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <StockIcon 
                    size={22} 
                    style={{marginTop:15,marginLeft:30, marginRight:5}} 
                    color='black'
                />
                <div className='tabText' 
                    style={tabName==='attendance' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Attendance</div>
            </Link>
            }
            {userRole === 'Admin' &&
            <Link 
                to='/settings'
                className='purchaseTabBox'
                style={tabName==='settings' ?
                {
                    backgroundColor:'#5CE65B'
                }:{
                    backgroundColor:'#EDF2F7'
                }}
            >
                <SettingsIcon 
                    size={24} 
                    style={{marginTop:10,marginLeft:30}} 
                    color='black'
                />
                <div className='tabText' 
                    style={tabName==='settings' ? {fontFamily:'PoppinsBold' }:{fontFamily:'PoppinsMedium'}}
                >Settings</div>
            </Link>
            }
            <div className='logoutIcon' onClick={handleLogout}>
                <LogoutIcon size={70} style={{marginLeft:15}} />
                <div id='logoutText'>Logout</div>
            </div>
            
        </div>
    )
}

export default LeftPanel;